export default __webpack_public_path__ + "static/media/ic-summary.4aea7dc0.svg";